import BFFAPI from './utils/BFFAPI';

class ProductInformationAPI extends BFFAPI {
  getProductInformation = (assetType: string) => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/${assetType}`
    );
    return this.fetch(req);
  };

  getAssetTypes = () => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/available-asset-types`
    );
    return this.fetch(req);
  };
}

export default new ProductInformationAPI('/fleet/secure/product-information');
